import lib from '@/library'
import Vue from 'vue'
import moment from 'moment'

const state = {
  participantInfos: [],
  cduNonPinnedEvents: [],
  cduPinnedEvents: [],
  cduOutrightEvents: [],
  cduSingleEvents: [],
  cduSingleEventsUltraWide: [],
  cduSingleEventMarkets: [],
  cduEventsLoaded: false,
  maxRotationIndex: 0,
  maxRotationIndex1: 0,
  showHeadlinesLines: 0,
  currentRotateIndex: 0,
  currentRotateIndex1: 0,
  numberOfOutrightTemplateColumns: 0,
  showMoreSelectionsMessage: false
}

const getters = {
  getParticipantInfos (state) {
    return state.participantInfos
  },
  getCduNonPinnedEvents (state) {
    return state.cduNonPinnedEvents
  },
  getCduPinnedEvents (state) {
    return state.cduPinnedEvents
  },
  getCduOutrightEvents (state) {
    return state.cduOutrightEvents
  },
  getCduSingleEvents (state) {
    return state.cduSingleEvents
  },
  getCduSingleEventsUltraWide (state) {
    return state.cduSingleEventsUltraWide
  },
  getCduSingleEventMarkets (state) {
    return state.cduSingleEventMarkets
  },
  getMaxRotationIndex (state) {
    return state.maxRotationIndex
  },
  getMaxRotationIndex1 (state) {
    return state.maxRotationIndex1
  },
  getCurrentRotateIndex (state) {
    return state.currentRotateIndex
  },
  getCurrentRotateIndex1 (state) {
    return state.currentRotateIndex1
  },
  getShowHeadlinesLines (state) {
    return state.showHeadlinesLines
  },
  getCduEventsLoaded (state) {
    return state.cduEventsLoaded
  },
  getNumberOfOutrightTemplateColumns (state) {
    return state.numberOfOutrightTemplateColumns
  },
  getShowMoreSelectionsMessage (state) {
    return state.showMoreSelectionsMessage
  }
}

const mutations = {
  setParticipantInfos (state, request) {
    state.participantInfos = request.participantinfos
  },
  setCduEvents (state, request) {
    // config
    var appConfig = (this.getters['cduState/getAppConfigForBrand'] && this.getters['cduState/getAppConfigForBrand'][request.displaytemplate]) || {}

    var maxNumOfPopularSelections = appConfig.maxNumOfPopularSelections
    var maxNumOfExpandedLineSelections = appConfig.maxNumOfExpandedLineSelections
    var maxNumOfLines = appConfig.maxNumOfLines
    var resultedEventRowSize = appConfig.resultedEventRowSize
    var numOfOutrightSelectionsColumns = appConfig.numOfOutrightSelectionsColumns
    var maxNumOfOutrightSelectionsInColumn = appConfig.maxNumOfOutrightSelectionsInColumn
    var maxNumOfOutrightSelections = numOfOutrightSelectionsColumns * maxNumOfOutrightSelectionsInColumn

    // vars
    var cduEvents = request.events

    cduEvents.splice(200)

    var populatedLines = 0
    var pinnedEvents = cduEvents.filter(ev => ev.ispinned)
    var nonPinnedEvents = cduEvents.filter(ev => !ev.ispinned)
    var numOfPinnedEventsLines = 0

    var pinnedEventsToDisplay = []
    var nonPinnedEventsToDisplay = []

    if (cduEvents && cduEvents.length > 0) {
      pinnedEvents.forEach(ev => {
        if (populatedLines < maxNumOfLines) {
          ev.isoutright = ev.markets && ev.markets[0] && ev.markets[0].isoutright
          let eventRows = 1

          if (ev.isoutright) {
            if (maxNumOfOutrightSelections < ev.markets[0].selections.length) {
              ev.markets[0].selections = ev.markets[0].selections.slice(0, maxNumOfOutrightSelections)
            }

            let numOfMarketSelections = ev.markets[0].selections.length
            if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn) {
              eventRows = 1
            } else if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn * 2) {
              eventRows = 2
            } else if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn * 3) {
              eventRows = 3
            } else if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn * 4) {
              eventRows = 4
            } else if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn * 5) {
              eventRows = 5
            } else {
              eventRows = 6
            }
          }

          if (ev.idfobolifestate === 'O') {
            if (ev.markets && ev.markets.length) {
              var numOfPopularSelections = 0
              var numOfExpandedSelections = 0

              // Mark popular markets
              if (ev.isoutright && ev.markets && ev.markets[0]) {
                ev.markets[0].isPopular = true
                if (ev.markets[0].selections) {
                  let numOfSelectionRows = Math.ceil(ev.markets[0].selections.length / numOfOutrightSelectionsColumns)
                  let activeSelectionsColumnNumber = 1
                  let currentSelectionRow = 0

                  Vue._.orderBy(ev.markets[0].selections, ['internalorder', 'currentprice', 'name']).forEach(sel => {
                    currentSelectionRow++
                    if (currentSelectionRow <= numOfSelectionRows) {
                      sel.selectioncolumn = activeSelectionsColumnNumber
                    } else {
                      activeSelectionsColumnNumber++
                      currentSelectionRow = 1
                      sel.selectioncolumn = activeSelectionsColumnNumber
                    }

                    if (sel.currentpriceup && sel.currentpricedown) {
                      sel.currentprice = 1 + sel.currentpriceup / sel.currentpricedown
                    }
                  })
                }
              } else {
                ev.markets.forEach(mk => {
                  let selectionsLength = 0

                  if (['TENNIS', 'SOCCER'].indexOf(ev.idfosporttype) > -1) {
                    selectionsLength = mk.selections.length * (mk.normalizedhandicapvalue || mk.currentmatchhandicap ? 1.7 : 1)
                  } else {
                    if (!ev.is2displayhorizontally && mk.big3markettype) {
                      if (mk.big3markettype === 'ML') {
                        selectionsLength = 1
                      } else {
                        selectionsLength = 1.7
                      }
                    } else {
                      selectionsLength = mk.selections.length * (mk.normalizedhandicapvalue || mk.currentmatchhandicap ? 1.7 : 1)
                    }
                  }

                  if (selectionsLength + numOfPopularSelections < maxNumOfPopularSelections) {
                    Vue.set(mk, 'isPopular', true)
                    numOfPopularSelections += selectionsLength
                  }
                })
              }

              if (!ev.isoutright && ev.isexpanded && ev.markets.filter(mk => !mk.isPopular).length > 0) {
                // Mark expanded markets
                eventRows += 1
                let breakLoop = false
                let markets = ev.markets.filter(mk => mk.selections.length < maxNumOfExpandedLineSelections)
                markets.filter(mk => !mk.isPopular).forEach(mk => {
                  if (!breakLoop) {
                    let selectionsLength = 0

                    if (['TENNIS', 'SOCCER'].indexOf(ev.idfosporttype) > -1) {
                      selectionsLength = mk.selections.length * (mk.normalizedhandicapvalue || mk.currentmatchhandicap ? 1.7 : 1)
                    } else {
                      if (!ev.is2displayhorizontally && mk.big3markettype) {
                        if (mk.big3markettype === 'ML') {
                          selectionsLength = 1
                        } else {
                          selectionsLength = 1.7
                        }
                      } else {
                        selectionsLength = mk.selections.length * (mk.normalizedhandicapvalue || mk.currentmatchhandicap ? 1.7 : 1)
                      }
                    }

                    if (selectionsLength <= maxNumOfExpandedLineSelections) {
                      if (selectionsLength + numOfExpandedSelections < maxNumOfExpandedLineSelections) {
                        mk.isExpanded = true
                        numOfExpandedSelections += selectionsLength
                      } else {
                        if (eventRows + 1 <= maxNumOfLines) {
                          mk.isExpanded = true
                          eventRows += 1
                          numOfExpandedSelections = 0 + selectionsLength
                        } else {
                          breakLoop = true
                        }
                      }
                    } else {
                      breakLoop = true
                    }
                  }
                })
              }
            }

            if (Math.ceil(populatedLines) + eventRows <= maxNumOfLines) {
              populatedLines = Math.ceil(populatedLines) + eventRows
              numOfPinnedEventsLines = Math.ceil(populatedLines)
              pinnedEventsToDisplay.push(ev)
            }
          } else {
            // RESULTED
            eventRows = resultedEventRowSize // 0.33

            if (populatedLines + eventRows <= maxNumOfLines) {
              populatedLines += eventRows
              numOfPinnedEventsLines = Math.ceil(populatedLines)
              pinnedEventsToDisplay.push(ev)
            }
          }
        }

        ev.markets = ev.markets && ev.markets.length ? ev.markets.filter((mk) => mk.isPopular) : []
      })

      if (populatedLines < maxNumOfLines && nonPinnedEvents.length > 0) {
        var eventPage = 0
        var skipEvent = false

        nonPinnedEvents.forEach(ev => {
          ev.isoutright = ev.markets && ev.markets[0] && ev.markets[0].isoutright
          let eventRows = 1

          if (ev.isoutright) {
            if (maxNumOfOutrightSelections < ev.markets[0].selections.length) {
              ev.markets[0].selections = ev.markets[0].selections.slice(0, maxNumOfOutrightSelections)
            }

            let numOfMarketSelections = ev.markets[0].selections.length
            if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn) {
              eventRows = 1
            } else if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn * 2) {
              eventRows = 2
            } else if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn * 3) {
              eventRows = 3
            } else if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn * 4) {
              eventRows = 4
            } else if (numOfMarketSelections <= maxNumOfOutrightSelectionsInColumn * 5) {
              eventRows = 5
            } else {
              eventRows = 6
            }
          }

          if (ev.idfobolifestate === 'O') {
            if (ev.markets && ev.markets.length) {
              var numOfPopularSelections = 0
              var numOfExpandedSelections = 0
              let breakLoop = false

              // Mark popular markets
              if (ev.isoutright && ev.markets && ev.markets[0]) {
                ev.markets[0].isPopular = true
                if (ev.markets[0].selections) {
                  let numOfSelectionRows = Math.ceil(ev.markets[0].selections.length / numOfOutrightSelectionsColumns)
                  let activeSelectionsColumnNumber = 1
                  let currentSelectionRow = 0

                  Vue._.orderBy(ev.markets[0].selections, ['internalorder', 'currentprice', 'name']).forEach(sel => {
                    currentSelectionRow++
                    if (currentSelectionRow <= numOfSelectionRows) {
                      sel.selectioncolumn = activeSelectionsColumnNumber
                    } else {
                      activeSelectionsColumnNumber++
                      currentSelectionRow = 1
                      sel.selectioncolumn = activeSelectionsColumnNumber
                    }

                    if (sel.currentpriceup && sel.currentpricedown) {
                      sel.currentprice = 1 + sel.currentpriceup / sel.currentpricedown
                    }
                  })
                }
              } else {
                ev.markets.forEach(mk => {
                  let selectionsLength = 0

                  if (['TENNIS', 'SOCCER'].indexOf(ev.idfosporttype) > -1) {
                    selectionsLength = mk.selections.length * (mk.normalizedhandicapvalue || mk.currentmatchhandicap ? 1.7 : 1)
                  } else {
                    if (!ev.is2displayhorizontally && mk.big3markettype) {
                      if (mk.big3markettype === 'ML') {
                        selectionsLength = 1
                      } else {
                        selectionsLength = 1.7
                      }
                    } else {
                      selectionsLength = mk.selections.length * (mk.normalizedhandicapvalue || mk.currentmatchhandicap ? 1.7 : 1)
                    }
                  }

                  if (selectionsLength + numOfPopularSelections < maxNumOfPopularSelections) {
                    mk.isPopular = true
                    numOfPopularSelections += selectionsLength
                  }
                })
              }

              if (ev.isexpanded && ev.markets.filter(mk => !mk.isPopular).length > 0) {
                // Mark expanded markets
                eventRows += 1

                let markets = ev.markets.filter(mk => mk.selections.length < maxNumOfExpandedLineSelections)
                markets.filter(mk => !mk.isPopular).forEach(mk => {
                  if (!breakLoop) {
                    let selectionsLength = 0

                    if (['TENNIS', 'SOCCER'].indexOf(ev.idfosporttype) > -1) {
                      selectionsLength = mk.selections.length * (mk.normalizedhandicapvalue || mk.currentmatchhandicap ? 1.7 : 1)
                    } else {
                      if (!ev.is2displayhorizontally && mk.big3markettype) {
                        if (mk.big3markettype === 'ML') {
                          selectionsLength = 1
                        } else {
                          selectionsLength = 1.7
                        }
                      } else {
                        selectionsLength = mk.selections.length * (mk.normalizedhandicapvalue || mk.currentmatchhandicap ? 1.7 : 1)
                      }
                    }

                    if (selectionsLength <= maxNumOfExpandedLineSelections) {
                      if (selectionsLength + numOfExpandedSelections < maxNumOfExpandedLineSelections) {
                        mk.isExpanded = true
                        numOfExpandedSelections += selectionsLength
                      } else {
                        if (eventRows + 1 <= maxNumOfLines - numOfPinnedEventsLines - Math.ceil(populatedLines || 0)) {
                          mk.isExpanded = true
                          eventRows += 1
                          numOfExpandedSelections = 0 + selectionsLength
                        } else {
                          breakLoop = true
                        }
                      }
                    } else {
                      breakLoop = true
                    }
                  }
                })
              }
            }

            if (Math.ceil(populatedLines) + eventRows > maxNumOfLines) {
              if (eventRows + numOfPinnedEventsLines > maxNumOfLines) {
                skipEvent = true
              } else {
                populatedLines = eventRows + numOfPinnedEventsLines + (ev.isoutright ? 0.1 : 0)
                eventPage += 1
              }
            } else {
              populatedLines = Math.ceil(populatedLines) + eventRows
            }
          } else {
            // RESULTED
            eventRows = resultedEventRowSize // 0.33

            if (populatedLines + eventRows > maxNumOfLines) {
              populatedLines = eventRows + numOfPinnedEventsLines
              eventPage += 1
            } else {
              populatedLines += eventRows
            }
          }

          if (!skipEvent) {
            ev.eventPage = eventPage
            nonPinnedEventsToDisplay.push(ev)
          } else {
            skipEvent = false
          }

          ev.markets = ev.markets && ev.markets.length ? ev.markets.filter((mk) => mk.isPopular) : []
        })
      }
    }

    populatedLines = Math.ceil(populatedLines)
    state.maxRotationIndex = nonPinnedEventsToDisplay.length > 0 ? nonPinnedEventsToDisplay[nonPinnedEventsToDisplay.length - 1].eventPage : 0
    state.cduPinnedEvents = pinnedEventsToDisplay
    state.cduNonPinnedEvents = nonPinnedEventsToDisplay
    state.showHeadlinesLines = populatedLines < maxNumOfLines ? maxNumOfLines - populatedLines : 0
  },
  setCduEvents2Columns (state, request) {
    // vars
    var appConfigForBrand = this.getters['cduState/getAppConfigForBrand']
    var appConfig = (appConfigForBrand && appConfigForBrand[request.displaytemplate]) || {}
    var cduConfig = this.getters['cduState/getScreenConfiguration']
    var populatedLines = 0
    var nonPinnedEventsToDisplay = []
    var cduEvents = appConfigForBrand.group2ColumnEventsBy === 'DATE' ? Vue._.orderBy(request.events, 'tsexpectedstart') : request.events
    var allEvents = cduEvents

    allEvents.splice(200)

    if (cduEvents && cduEvents.length > 0) {
      // config
      // var maxNumOfPopularSelections = 7
      // add one more row if all events are same live/prematch status and of same sporttype

      var maxNumOfLines = 0
      var maxNumOfLinesInColumn = 0

      if (appConfigForBrand.group2ColumnEventsBy === 'DATE') {
        maxNumOfLines = cduEvents.length === cduEvents.filter(ev => ev.tsdate === cduEvents[0].tsdate).length
          ? appConfig.maxNumOfLines2ColumnsameSport * 2 : appConfig.maxNumOfLines2Column * 2
        maxNumOfLinesInColumn = cduEvents.length === cduEvents.filter(ev => ev.tsdate === cduEvents[0].tsdate).length
          ? appConfig.maxNumOfLines2ColumnsameSport : appConfig.maxNumOfLines2Column
      } else {
        maxNumOfLines = cduEvents.length === cduEvents.filter(ev => ev.idfosporttype === cduEvents[0].idfosporttype && ev.isliveevent === cduEvents[0].isliveevent).length
          ? appConfig.maxNumOfLines2ColumnsameSport * 2 : appConfig.maxNumOfLines2Column * 2
        maxNumOfLinesInColumn = cduEvents.length === cduEvents.filter(ev => ev.idfosporttype === cduEvents[0].idfosporttype && ev.isliveevent === cduEvents[0].isliveevent).length
          ? appConfig.maxNumOfLines2ColumnsameSport : appConfig.maxNumOfLines2Column
      }

      if (populatedLines < maxNumOfLines && allEvents.length > 0) {
        var eventPage = 0

        // Only sports with big3 markets are allowed on 2columns mode
        allEvents.forEach((ev, index) => {
          if (appConfigForBrand.group2ColumnEventsBy === 'DATE' && ev.tsdate === undefined) {
            ev.tsdate = (ev.tsexpectedstart && ev.tsexpectedstart.indexOf('T') > -1 && ev.tsexpectedstart.split('T')[0]) || -1
            ev.tsDate = ev.tsdate
            if (window.ctsautoconf.zoneTimeOffset) {
              ev.tsDate = (ev.tsExpectedStart && ev.tsExpectedStart.indexOf('T') > -1 && ev.tsExpectedStart.split('T')[0]) || -1
            }
          }

          if (appConfigForBrand.group2ColumnEventsBy === 'DATE') {
            ev.showeventheader = index === 0 || allEvents[index - 1].tsdate !== ev.tsdate
          } else {
            ev.showeventheader = index === 0 || allEvents[index - 1].idfosporttype !== ev.idfosporttype ||
              allEvents[index - 1].isliveevent !== ev.isliveevent
          }

          ev.eventrows = ev.showeventheader ? 1 : appConfigForBrand[request.displaytemplate].noHeaderHeightRation2Column || 0.75

          if (ev.idfobolifestate === 'O') {
            if (ev.markets && ev.markets.length) {
              // var numOfPopularSelections = 0

              // Mark popular markets
              if (['TENNIS', 'SOCCER', 'BOXING', 'MMA'].indexOf(ev.idfosporttype) > -1 && (lib.cdu.brands.isWhite1() || lib.cdu.brands.isTranslux5())) {
                // NON Big3 sports
                let popularMarket = ev.markets.find(mk => lib.betting.market.isMoneyline(mk))
                if (popularMarket) {
                  popularMarket.isPopular = true
                }
                ev.markets = [popularMarket]
              } else {
                // Big3 sports
                ev.markets = lib.betting.market.getFirstBig3Markets(ev.markets)
                ev.markets.forEach(mk => {
                  mk.isPopular = true
                })
              }
            }

            if (populatedLines + ev.eventrows > maxNumOfLines) {
              populatedLines = Math.ceil(ev.eventrows)
              ev.eventrows = 1
              ev.displaycol = 1
              eventPage += 1
            } else {
              if (populatedLines + ev.eventrows > maxNumOfLinesInColumn) {
                if (allEvents.filter(ev => ev.displaycol === 2 && ev.eventPage === eventPage).length === 0) {
                  ev.eventrows = 1
                }
                ev.displaycol = 2
              } else {
                if (allEvents.filter(ev => ev.displaycol === 1 && ev.eventPage === eventPage).length === 0) {
                  ev.eventrows = 1
                }
                ev.displaycol = 1
              }
              populatedLines = populatedLines + ev.eventrows
            }
          } else {
            // RESULTED
            if (populatedLines + ev.eventrows > maxNumOfLines) {
              populatedLines = Math.ceil(ev.eventrows)
              ev.eventrows = 1
              ev.displaycol = 1
              eventPage += 1
            } else {
              if (populatedLines + ev.eventrows > maxNumOfLinesInColumn) {
                if (allEvents.filter(ev => ev.displaycol === 2 && ev.eventPage === eventPage).length === 0) {
                  ev.eventrows = 1
                }
                ev.displaycol = 2
              } else {
                if (allEvents.filter(ev => ev.displaycol === 1 && ev.eventPage === eventPage).length === 0) {
                  ev.eventrows = 1
                }
                ev.displaycol = 1
              }
              populatedLines += ev.eventrows
            }
          }

          ev.eventPage = eventPage
          nonPinnedEventsToDisplay.push(ev)
        })
      }
    }

    // If stats enabled prepare events for display
    if (cduConfig.is2showstats && appConfigForBrand.showParticipantStats) {
      lib.cdu.templates.stats.reArangeEventsPerPageFor2Column(nonPinnedEventsToDisplay)
    }

    populatedLines = Math.ceil(populatedLines)
    state.maxRotationIndex = nonPinnedEventsToDisplay.length > 0 ? nonPinnedEventsToDisplay[nonPinnedEventsToDisplay.length - 1].eventPage : 0
    state.cduNonPinnedEvents = nonPinnedEventsToDisplay
    state.showHeadlinesLines = false
  },
  setCduOutrightEvents (state, request) {
    // vars
    var cduEvents = request.events
    // var maxDisplayPage = 0
    var showMoreSelectionsMessage = false
    var numberOfColumns = 0
    var maxRotationIndex = 0

    var outrightEvents = []

    if (lib.betting.event.hasOutrightEvents(cduEvents)) {
      outrightEvents = lib.betting.event.getOutrightEvents(cduEvents)
      if (lib.cdu.config.isHalfTemplate()) {
        outrightEvents = outrightEvents.filter(ev => ev.markets[0].selections.length <= 10)
        outrightEvents.splice(2)
      } else {
        outrightEvents.splice(1)
      }
    }

    outrightEvents.forEach((outrightEvent) => {
      if (outrightEvent) {
        Vue.set(outrightEvent, 'outrightMarket', (outrightEvent.markets.find(mk => mk.isoutright)) || undefined)

        if (outrightEvent.outrightMarket && outrightEvent.outrightMarket.selections) {
          outrightEvent.outrightMarket.selections.forEach(sel => {
            Vue.set(sel, 'decimalprice', (1 + sel.currentpriceup / sel.currentpricedown))
          })

          outrightEvent.outrightMarket.selections = Vue._.orderBy(outrightEvent.outrightMarket.selections, ['internalorder', 'decimalprice'])

          // use this line for development propose only - put outright market and splice selections array to test different cases
          // current placeholders are:
          // template1: 0-10 selections
          // template2: 10-20 selections
          // template3: 20-34 selections
          // template4: 34-44 selections rotate - >44 selections show message
          // outrightEvent.outrightMarket.selections = outrightEvent.outrightMarket.selections.slice(0, 44)

          if (outrightEvent.outrightMarket.selections.length > 44) {
            // template4
            showMoreSelectionsMessage = true
            outrightEvent.outrightMarket.selections = outrightEvent.outrightMarket.selections.slice(0, 39)
          }

          // NUMBER OF COLUMNS
          if (outrightEvent.outrightMarket.selections.length <= 10) {
            // template1
            numberOfColumns = 1
          } else if (outrightEvent.outrightMarket.selections.length <= 20) {
            // template2
            numberOfColumns = 2
          } else if (outrightEvent.outrightMarket.selections.length <= 34) {
            // template3
            numberOfColumns = 3
          } else {
            // template4
            numberOfColumns = 4
          }
          state.numberOfOutrightTemplateColumns = numberOfColumns

          // NUMBER OF ROWS
          var numberOfRowsInColumn = 0
          if (numberOfColumns === 1 || numberOfColumns === 2) {
            // template1
            // template2
            numberOfRowsInColumn = Math.ceil(outrightEvent.outrightMarket.selections.length / numberOfColumns)
          } else if (numberOfColumns === 3) {
            // template3
            if (outrightEvent.outrightMarket.selections.length > 30) {
              numberOfRowsInColumn = 10
            } else {
              numberOfRowsInColumn = Math.ceil(outrightEvent.outrightMarket.selections.length / numberOfColumns)
            }
          } else if (numberOfColumns === 4) {
            // template4
            if (outrightEvent.outrightMarket.selections.length > 40) {
              numberOfRowsInColumn = 10
            } else {
              numberOfRowsInColumn = Math.ceil(outrightEvent.outrightMarket.selections.length / numberOfColumns)
            }
          }

          // ARRANGE SELECTIONS IN COLUMNS WITH PAGING
          let activeSelectionsColumnNumber = 1
          let currentSelectionRow = 0
          // let selectionDisplayPage = 0

          if (numberOfColumns === 1 || numberOfColumns === 2) {
            // template1
            // template2
            outrightEvent.outrightMarket.selections.forEach(sel => {
              currentSelectionRow++
              sel.displaypage = -1

              if (currentSelectionRow <= numberOfRowsInColumn) {
                sel.selectioncolumn = activeSelectionsColumnNumber
              } else {
                activeSelectionsColumnNumber++
                currentSelectionRow = 1
                sel.selectioncolumn = activeSelectionsColumnNumber
              }

              if (sel.currentpriceup && sel.currentpricedown) {
                sel.currentprice = 1 + sel.currentpriceup / sel.currentpricedown
              }
            })
          } else if (numberOfColumns === 3 || numberOfColumns === 4) {
            // template3
            // template4
            outrightEvent.outrightMarket.selections.forEach((sel, index) => {
              currentSelectionRow++

              if (activeSelectionsColumnNumber < numberOfColumns) {
                if (currentSelectionRow <= numberOfRowsInColumn) {
                  sel.selectioncolumn = activeSelectionsColumnNumber
                } else {
                  activeSelectionsColumnNumber++
                  currentSelectionRow = 1
                  sel.selectioncolumn = activeSelectionsColumnNumber
                }
              } else {
                sel.selectioncolumn = numberOfColumns
              }

              if (outrightEvent.outrightMarket.selections.length > numberOfColumns * 10) {
                var numOfOverflowSelections = outrightEvent.outrightMarket.selections.length - numberOfColumns * 10
                var numOfSelectionsToRotate = window.ctsautoconf.numberOfOutrightTemplateSelectionsToRotate === 'DYNAMIC'
                ? (numOfOverflowSelections <= 5 ? numOfOverflowSelections : 5)
                : (window.ctsautoconf.numberOfOutrightTemplateSelectionsToRotate !== undefined ? window.ctsautoconf.numberOfOutrightTemplateSelectionsToRotate : 5)
                if (index < numberOfColumns * 10 - numOfSelectionsToRotate) {
                  sel.displaypage = -1
                } else {
                  sel.displaypage = 0
                }
              } else {
                sel.displaypage = -1
              }

              if (sel.currentpriceup && sel.currentpricedown) {
                sel.currentprice = 1 + sel.currentpriceup / sel.currentpricedown
              }
            })
          }
        }
      }
    })

    state.showMoreSelectionsMessage = showMoreSelectionsMessage
    if (outrightEvents.length > 0) {
      maxRotationIndex = (outrightEvents[0] && outrightEvents[0].outrightMarket && outrightEvents[0].outrightMarket.selections &&
        outrightEvents[0].outrightMarket.selections.filter(sel => sel.displaypage === 0).length - 5) || 0
    }
    state.maxRotationIndex = maxRotationIndex > 0 ? maxRotationIndex : 0
    state.cduOutrightEvents = outrightEvents
  },
  setCduSingleEvents (state, request) {
    // vars
    var appConfigForBrand = this.getters['cduState/getAppConfigForBrand']
    var cduConfig = this.getters['cduState/getScreenConfiguration']
    var appConfig = (appConfigForBrand && appConfigForBrand[request.displaytemplate]) || {}
    var events = request.events.filter(ev => ev.idfobolifestate === 'O')
    var maxNumOfSelectionsPerCol = appConfig.maxNumOfSelectionsPerColSingleEvent
    var marketHeaderHeightComparedToSelection = 0.829
    var big3MarketHeightComparedToSelection = 2.52
    var gapBetweenSelectionsComparedToSelection = 0.055

    events.forEach((singleEvent, index) => {
      singleEvent.eventPage = index
      if (singleEvent && singleEvent.markets && singleEvent.markets.length > 0) {
        var currentColumn = 0
        var currentSelNumberInColumn = 0

        // Big3 Coupon
        var big3Markets = null

        if (['SOCCER', 'TENNIS', 'BOXING', 'MMA'].indexOf(singleEvent.idfosporttype) === -1) {
          big3Markets = lib.betting.market.getFirstBig3Markets(singleEvent.markets)

          if (big3Markets.length > 0) {
            big3Markets.forEach(mk => {
              mk.isPopular = true
            })
          }
        } else {
          // If Tennis and Soccer get first Moneyline market
          if (lib.betting.event.hasMoneyline(singleEvent)) {
            big3Markets = lib.betting.event.getMoneylineMarkets(singleEvent)
            if (big3Markets.length > 0) {
              big3Markets.splice(1)
              big3Markets[0].isPopular = true
            }
          }
        }
        if (big3Markets && big3Markets.length > 0) {
          currentSelNumberInColumn += big3MarketHeightComparedToSelection
        }

        var hadIndex = 0
        var isOdd = false
        var page = 0

        // Other markets
        singleEvent.maxMarketRotatingIndex = 0
        singleEvent.markets.filter(mk => !mk.isPopular).forEach(mk => {
          var marketHeight = marketHeaderHeightComparedToSelection + mk.selections.length + (mk.selections.length * gapBetweenSelectionsComparedToSelection)
          var marketValid = mk.selections && mk.selections.length > 0 && marketHeight <= maxNumOfSelectionsPerCol

          if (marketValid) {
            if (lib.betting.market.isHad(mk) && lib.betting.market.numberOfSelections(mk) <= 3) {
              isOdd = hadIndex % 2
              hadIndex++
            } else {
              isOdd = false
              hadIndex = 0
            }

            // If column is full switch to other column

            // Sum of selections in column
            if ((!isOdd && lib.betting.market.isHad(mk)) || !lib.betting.market.isHad(mk)) {
              if (marketHeight + currentSelNumberInColumn > maxNumOfSelectionsPerCol) {
                // currentColumn++
                if (lib.cdu.config.isHalfTemplate()) {
                  currentColumn = 0
                } else {
                  let showStats = cduConfig.is2showstats && appConfigForBrand.showParticipantStats
                  currentColumn = currentColumn || showStats ? 0 : 1
                }

                if (currentColumn === 0) {
                  page++
                  currentSelNumberInColumn = (big3Markets && big3Markets.length > 0) ? big3MarketHeightComparedToSelection : 0

                  if ((marketHeight + currentSelNumberInColumn) < maxNumOfSelectionsPerCol) {
                    marketValid = true
                  } else {
                    marketValid = false
                  }
                } else {
                  currentSelNumberInColumn = 0
                }
              }

              if (marketValid) {
                currentSelNumberInColumn += marketHeight
              }
            }

            if (marketValid) {
              mk.currentColumn = currentColumn
              mk.page = page
              singleEvent.maxMarketRotatingIndex = page
            }
          }
        })
      }
    })

    if (lib.cdu.brands.isUltraWide()) {
      if (events && events.length > 0) {
        state.maxRotationIndex = events.length - 1
        state.cduSingleEventsUltraWide = events
      } else {
        state.maxRotationIndex = 0
        state.cduSingleEvents = []
        state.cduSingleEventsUltraWide = []
        state.cduSingleEventMarkets = []
      }
    } else {
      if (lib.cdu.config.isHalfTemplate()) {
        events.splice(2) // First two events will be used
      } else {
        events.splice(1) // Only first event will be used
      }

      // Make groups by page from markets
      if (events.length > 0) {
        events.forEach((event, index) => {
          if (event.markets) {
            event.marketsByPages = []
            for (var i = 0; i <= event.maxMarketRotatingIndex; i++) {
              event.marketsByPages[i] = {}
              event.marketsByPages[i].page = i
              event.marketsByPages[i].markets = event.markets.filter(mk => mk.page === i)
            }
            if (lib.cdu.config.isHalfTemplate()) {
              if (index === 0) {
                state.maxRotationIndex = event.maxMarketRotatingIndex
                event.half = 0
              } else {
                state.maxRotationIndex1 = event.maxMarketRotatingIndex
                event.half = 1
              }
            } else {
              state.maxRotationIndex = event.maxMarketRotatingIndex
            }
          }
        })

        events.forEach(event => { event.resetCurrentIndex = true })
        // If the same event comes on same position, dont reset their rotate index
        lib.cdu.templates.singleEvent.indexesOfSameEvent(state.cduSingleEvents, events).forEach(index => {
          events[index].resetCurrentIndex = false
        })

        state.cduSingleEvents = events
      } else {
        state.maxRotationIndex = 0
        state.maxRotationIndex1 = 0
        state.cduSingleEvents = []
        state.cduSingleEventsUltraWide = []
        state.cduSingleEventMarkets = []
      }
    }
  },
  setCduEventsLoaded (state, value) {
    state.cduEventsLoaded = value
  },
  setCurrentRotateIndex (state, currentRotateIndex) {
    state.currentRotateIndex = currentRotateIndex
  },
  setCurrentRotateIndex1 (state, currentRotateIndex) {
    state.currentRotateIndex1 = currentRotateIndex
  }
}

const actions = {
  fetchCduEvents (context, request) {
    return new Promise((resolve) => {
      lib.kansas.cduevents({
        maxnumofmarketsperevent: 50,
        screenid: request.screenId,
        flags: 'SHOWONCDU'
      }).then(response => {
        var cduConfig = context.rootState.cduState.screenConfiguration
        if (response.data && response.data.events) {
          response.data.events.forEach((ev, index) => {
            ev.tsExpectedStart = ev.tsexpectedstart
            if (window.ctsautoconf.zoneTimeOffset) {
              ev.tsExpectedStart = moment(ev.tsexpectedstart).add(window.ctsautoconf.zoneTimeOffset, 'hours').format('YYYY-MM-DDTHH:mm:ss')
            }
          })
          if (cduConfig.is2showsingleevent) {
            context.commit('setCduSingleEvents', { events: response.data.events, displaytemplate: request.displaytemplate })
          } else if (cduConfig.is2showoutrightevents) {
            context.commit('setCduOutrightEvents', { events: response.data.events, displaytemplate: request.displaytemplate })
          } else if (cduConfig.is2showeventsin2columns) {
            context.commit('setCduEvents2Columns', { events: response.data.events, displaytemplate: request.displaytemplate })
          } else {
            context.commit('setCduEvents', { events: response.data.events, displaytemplate: request.displaytemplate })
          }

          if (response.data.participantinfos) {
            context.commit('setParticipantInfos', { participantinfos: response.data.participantinfos })
          }
        } else {
          context.commit('setCduEvents', { events: [], displaytemplate: request.displaytemplate })
          context.commit('setParticipantInfos', { participantinfos: [] })
        }
      }).catch((error) => {
        console.log(error)
        context.commit('setCduEvents', { events: [], displaytemplate: request.displaytemplate })
      }).finally(() => {
        context.commit('setCduEventsLoaded', true)
        resolve()
      })
    })
  },
  cleanAllEvents (context) {
    context.commit('setCduEvents', { events: [], displaytemplate: undefined })
    context.commit('setCduEvents2Columns', { events: [], displaytemplate: undefined })
    context.commit('setCduOutrightEvents', { events: [], displaytemplate: undefined })
    context.commit('setCduSingleEvents', { events: [], displaytemplate: undefined })
    context.commit('setParticipantInfos', { participantinfos: [] })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/bettingOffer.js